import axios from '@axios'
import store from '@/store'

const mapListParamsToApi = (params) => {
  if (!params) return {}
  const { sortBy, sortDesc, unit, user, ...rest } = params
  return {
    ...rest,
    ...(sortBy != null && { sort_by: sortBy }),
    ...(sortDesc != null && { sort_desc: sortDesc }),
    ...(unit != null && { id_unit: unit }),
    ...(user != null && { id_user: user }),
  }
}

const emptyPagination = () => ({ data: [], meta: { total: 0 }, links: {} })

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(item => ({
        value: item.id,
        label: item.unit ? item.unit.description : String(item.id),
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async export(_, params) {
      const apiParams = mapListParamsToApi(params)
      const response = await axios.get('v1/patrol-logs', {
        params: apiParams,
        responseType: 'blob',
      })

      if (!response.data) {
        return
      }

      const url = window.URL.createObjectURL(
        new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })
      )
      const link = document.createElement('a')
      link.href = url
      const disposition = response.headers['content-disposition']
      const downloadName = disposition ? disposition.split('filename=')[1] : 'export.xlsx'
      link.setAttribute('download', downloadName)
      document.body.appendChild(link)
      link.click()
      link.remove()

      store.dispatch('grid/updateDownloadNotification', {
        id: downloadName,
        progress: 100,
        completed: true,
        view: 'PatrolLogs',
        url,
        download: downloadName,
        title: 'Reporte Bitácora de Patrullaje',
        body: 'Descarga completa',
        error: false,
        timestamp: `${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`,
      })
    },

    async getAll({ commit }, params) {
      const apiParams = mapListParamsToApi(params)
      const { data } = await axios.get('v1/patrol-logs', { params: apiParams })

      if (!data || !data.success) {
        commit('setData', [])
        return emptyPagination()
      }

      const raw = data.data
      const isNested = raw && !Array.isArray(raw) && Array.isArray(raw.data)
      const items = isNested ? raw.data : (Array.isArray(raw) ? raw : [])
      const meta = isNested ? (raw.meta || {}) : (data.meta || {})
      const links = isNested ? (raw.links || {}) : (data.links || {})
      commit('setData', items)
      return { data: items, meta, links }
    },
    async getById(_, id) {
      const { data } = await axios.get(`v1/patrol-logs/${id}`)
      return data
    },
    async add(_, params) {
      const { data } = await axios.post('v1/patrol-logs', params)
      return data
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/patrol-logs/${id}`, params)
      return data
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/patrol-logs/${id}`)
      return data
    },
    clear({ commit }) {
      commit('setData', [])
    },
  },
}
